<template>
  <div>

    <MfaPopup v-if="mfa"></MfaPopup>

    <h1>Double Authentification du compte</h1>
    <!-- Bloc d'affichage du QR Code -->
    <div class="alert alert-light" role="alert" v-if="displayQr">
      <h3>Activation de la double authentification</h3>
      <p>Certains modules de l'Intranet CMEM sont sécurisés par une double authentification. Cela signifie qu'il vous sera impossible d'y accéder sans utiliser ce mécanisme visant à renforcer la sécurité de votre compte. Ce code ne s'affichera qu'une seule fois. Veillez à le scanner via l'application "Microsoft Authenticator" ou "Google Authenticator". Ce QR Code ne s'affichera plus par la suite.</p>
      <p class="text-center">
        <qrcode-vue :value="url" :size="size" level="H" v-if="displayQr" class="float-right" />
      </p>
    </div>

    <!-- Information si déjà une clé déjà existante -->
    <div class="alert alert-danger" role="alert" v-if="mfa && !displayQr">
      Attention, vous possédez déjà une clé de double authentification. Si vous en générez une nouvelle, la précédente sera effacée !
    </div>

    <!-- Génération d'une nouvelle clé -->
    <div class="alert alert-light" role="alert" v-if="!displayQr">
      <div>
        <p>Attention ! Si vous avez déjà généré une clé de double authentification, la précédente sera écrasée.</p>
      </div>
      <div class="float-right">
        <button class="btn btn-primary" v-on:click="generateSecretKey()">Générer</button>
      </div>
    </div>

  </div>
</template>

<script>

  import MfaPopup from "@/components/MfaPopup";

  import { totp, generateKey } from "@/utils/mfa";
  import QrcodeVue from 'qrcode.vue';

  export default {
    name: "Mfa",
    components: { QrcodeVue, MfaPopup },
    data() {
      return {
        url: "",
        size: 300,
        displayQr: false,
        mfa: false,
      }
    },
    mounted() {
      this.checkIf2fA();
    },

    computed: {
      
    },
    methods: {
      // Vérifie l'existence d'une double auth
      checkIf2fA() {
        totp().then(r => {
          this.url = r;
          if (!this.url == "") {
            this.mfa = true;
          }
        })
      },

      // Génère une clé secrète
      generateSecretKey() {
        generateKey().then(r => {
          alert(r);
          this.displayQrCode();
        })
      },

      // Affiche le QR Code
      displayQrCode() {
        totp().then(r => {
          this.url = r;
          if (!this.url == "") {
            this.displayQr = true;
          }
        })
      },
    }
  }
</script>

<style scoped>
  button.btn-primary {
      background: #A7C13C;
      border-color: #A7C13c;
  }
 </style>



// WEBPACK FOOTER //
// src/pages/Securite/Mfa.vue